/*TODO: Implement the actual task, dummy component as placeholder for manual testing */
import { Box, Text } from '@factorialco/deprecated-design-system'

import TaskFooter from 'modules/inbox_tasks/activities/Task/Footer'
import {
  TaskCustomComponent,
  TaskDefinition,
  TaskFooterComponent,
} from 'modules/inbox_tasks/lib/abstraction'

type State = {
  uploadedFiles?: string[]
}

const UploadDocumentTaskContent: TaskCustomComponent<'ProcurementUploadDocumentTask', State> = ({
  taskable,
}) => {
  if (!taskable) return null

  const purchaseRequest = taskable.purchaseRequest

  return (
    <Box gap="s24">
      <Box gap="s12">
        <Text size="500">Purchase Request</Text>
        <Box gap="s8">
          <Box gap="s8">
            <Text size="500">Description:</Text>
            <Text size="500">{purchaseRequest?.description || '-'}</Text>
          </Box>

          {purchaseRequest?.cost && (
            <Box gap="s8">
              <Text size="500">Amount:</Text>
              <Text size="500">
                {purchaseRequest.cost.currency} {(purchaseRequest.cost.cents / 100).toFixed(2)}
              </Text>
            </Box>
          )}

          {purchaseRequest?.requesterEmployee && (
            <Box gap="s8">
              <Text size="500">Requester:</Text>
              <Text size="500">{purchaseRequest.requesterEmployee.fullName}</Text>
            </Box>
          )}
        </Box>
      </Box>

      <Box gap="s12">
        <Text size="500">Upload Files</Text>
      </Box>

      {taskable.files && taskable.files.length > 0 && (
        <Box gap="s12">
          <Text size="500">Existing Files</Text>
          <Box gap="s8">
            {taskable.files.map((file) => (
              <Text size="500" key={file.fileId}>
                • {file.filename}
              </Text>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}

const UploadDocumentTaskFooter: TaskFooterComponent<'ProcurementUploadDocumentTask', State> = ({
  taskId,
  taskable,
}) => {
  if (!taskable?.id) {
    return null
  }

  return (
    <TaskFooter
      taskId={taskId}
      onClickPrimaryAction={async () => {
        return true
      }}
    />
  )
}

export const UploadDocumentTaskDefinition: TaskDefinition<'ProcurementUploadDocumentTask', State> =
  {
    taskableTypename: 'ProcurementUploadDocumentTask',
    initialState: {},
    component: UploadDocumentTaskContent,
    footer: UploadDocumentTaskFooter,
    getTitle: ({ info }) => {
      const description = info.purchaseRequest?.description

      if (!description) {
        return 'no description'
      }

      return `${description}`
    },
    getMetadata: ({ info }) => {
      return [info.purchaseRequest?.description || '']
    },
  }
